import * as React from "react";
import type { SVGProps } from "react";
const SvgIconInfo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 15 15"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.97.02c-1.28.08-2.53.5-3.6 1.2q-1.3.86-2.15 2.15c-.45.7-.81 1.52-1 2.31-.5 2.03-.13 4.16 1 5.89q.86 1.3 2.15 2.15c.7.45 1.52.81 2.31 1 2.02.5 4.16.13 5.89-1q1.3-.86 2.15-2.15c.45-.7.81-1.52 1-2.31.42-1.7.23-3.47-.52-5.03-.38-.79-.83-1.42-1.45-2.04Q11.46.91 9.71.34C8.86.07 7.9-.05 6.97.02m.01 1.14c-1.92.15-3.69 1.18-4.76 2.78Q1.38 5.17 1.19 6.7c-.05.31-.05 1.23 0 1.54.1.75.28 1.36.6 2.02.33.65.7 1.17 1.2 1.68.52.51 1.04.88 1.69 1.2.66.33 1.27.51 2.02.61.31.04 1.23.04 1.54 0 .75-.1 1.36-.28 2.02-.6.65-.33 1.17-.7 1.68-1.2.51-.52.88-1.04 1.2-1.69.27-.54.43-1 .54-1.57.09-.47.1-.62.1-1.22s-.01-.75-.1-1.22c-.11-.57-.27-1.03-.54-1.57-.32-.65-.69-1.17-1.2-1.68s-1.03-.88-1.68-1.2-1.23-.5-1.97-.6c-.17-.03-.33-.04-.72-.04zm.39 2.3c-.33.03-.61.28-.7.6q-.03.1-.03.23 0 .34.24.58.25.25.58.25.36 0 .6-.26.25-.24.24-.57 0-.35-.24-.6-.29-.28-.7-.23m-1.1 2.93c-.23.05-.41.27-.43.5-.02.25.13.5.36.58.08.03.14.04.4.04l.3.01v2.56H5.74l-.1.06q-.2.09-.29.27c-.04.08-.04.11-.04.24s0 .17.04.24q.1.19.29.28l.1.05h3.44l.1-.05q.2-.1.29-.28c.04-.07.04-.1.04-.24s0-.16-.04-.24q-.1-.18-.29-.27l-.1-.05h-.57l-.57-.01V8.5q0-1.58-.02-1.66-.07-.3-.33-.42l-.1-.05h-.63c-.46 0-.65 0-.7.02"
      fill="currentColor"
    />
  </svg>
);
export default SvgIconInfo;
